//REDUX-FORM reducer plugin to initialize the form with values

import {actionTypes} from "redux-form";
import assign from "lodash/assign";

export default {
  "employment-application": (state, action) => {

      switch(action.type) {
        case actionTypes.REGISTER_FIELD:
          if(action.payload.name == "employmentHistory" && state.values && !state.values.employmentHistory){
            let values = assign({}, state.values, {
              employmentHistory: [{}]
            });
            return assign({}, state, {
              values
            });
          }else{
            return state;
          }
        case actionTypes.BLUR:
          try{
            let cleaned = assign({}, state.values, {recaptcha: null});
            localStorage.setItem("employment-application", JSON.stringify(cleaned));
          }catch(ex){

          }
        default:
          return state
      }
    }
}
